import { Activity } from 'lucide-react';
import React from 'react';

import { cn } from '@/utils';

import {
  getMosBgColor,
  getMosColor,
  getMosQuality,
  type MosQuality,
} from '../hooks/useCallQuality';

interface MosIndicatorProps {
  mos: number | null;
  onClick?: () => void;
  className?: string;
}

const QUALITY_LABELS: Record<MosQuality, string> = {
  excellent: 'Excellent',
  good: 'Good',
  fair: 'Fair',
  poor: 'Poor',
  bad: 'Bad',
  unknown: '...',
};

/**
 * Small pill that shows the current MOS score in the dialpad header.
 * Color-coded by quality tier. Clicking toggles the call quality debugger.
 */
export function MosIndicator({ mos, onClick, className }: MosIndicatorProps) {
  const quality = getMosQuality(mos);
  const colorClass = getMosColor(quality);
  const bgClass = getMosBgColor(quality);

  return (
    <button
      type="button"
      onClick={onClick}
      title={`Call quality: ${QUALITY_LABELS[quality]}. Click to open network debugger.`}
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold transition-colors',
        'hover:ring-1 hover:ring-ring focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
        bgClass,
        colorClass,
        className,
      )}
    >
      <Activity className="h-3 w-3" />
      {mos !== null ? mos.toFixed(1) : '--'}
    </button>
  );
}
